import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  frame: {
    width: '100%',
    height: '100%',
    minWidth: '1280px',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    [breakpoints.down(1150)]: {
      minWidth: '160vh',
      transform: 'translate(-25%)',
    },
    [breakpoints.down(769)]: {
      minWidth: '160vh',
      transform: 'translate(-30%)',
    },
    [breakpoints.down(600)]: {
      minWidth: '160vh',
      transform: 'translate(-33.5%)',
    },
    [breakpoints.down(426)]: {
      minWidth: '160vh',
      transform: 'translate(-32%)',
    },
    [breakpoints.down(376)]: {
      minWidth: '160vh',
      transform: 'translate(-35.5%)',
    },
  },
  videoWrapper: {
    height: 'calc(100vh - 65px)',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
}), { name: 'BackgroundVideo' });

export type Props = {
  title: string;
  src: string;
  localStorageIdEnableVideo?: string;
  children?: React.ReactNode;
};
const BackgroundVideo = ({
  localStorageIdEnableVideo,
  children,
  title,
  src,
} : Props) => {
  const classes = useStyles();

  // Check local storage
  const backgroundVideoDisable = (localStorageIdEnableVideo)
    ? localStorage.getItem(localStorageIdEnableVideo)
    : false;

  return (
    <div className={classes.videoWrapper}>
      {children}
      {
        !backgroundVideoDisable
        && (
          <iframe
            className={classes.frame}
            title={title}
            src={src}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="autoplay"
            data-ready="true"
          />
        )
      }
    </div>
  );
};

export default BackgroundVideo;
